import React, { PropsWithChildren } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { FloatingMessageProviderProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import { Button } from "@mui/material";
import Icon from "../icon";
import Message from "../messages/reduxMessage";
import { SnackbarKey, SnackbarProvider } from "notistack";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FloatingMessageProvider: React.FC<PropsWithChildren<FloatingMessageProviderProps>> = (props) => {
  const notistackRef = React.useRef<SnackbarProvider>(null);
  const action = React.useCallback(
    (key: SnackbarKey) => (
      <Button onClick={() => notistackRef.current?.closeSnackbar(key)} className={cssExports.messageCloseButton}>
        <Icon icon={IconDefinitionConstants.WTimesThin} />
      </Button>
    ),
    []
  );

  const messageClass = useSelector((store: AppState) => store.util.floatingMessageClass);

  return (
    <SnackbarProvider
      domRoot={props.customRootId ? document.getElementById(props.customRootId) ?? undefined : undefined}
      maxSnack={10}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        containerRoot: clsx(
          cssExports.snackbarContainer,
          cssExports.snackbarContainerCommon,
          messageClass,
          props.className
        ),
        root: cssExports.snackbar,
        variantInfo: cssExports.info,
        variantError: cssExports.danger,
        variantSuccess: cssExports.success,
        variantWarning: cssExports.warning,
      }}
      preventDuplicate
      ref={notistackRef}
      action={action}
      iconVariant={{
        error: <Icon className={cssExports.snackBarIcon} icon={IconDefinitionConstants.WWarningCanvas} />,
        info: <Icon className={cssExports.snackBarIcon} icon={IconDefinitionConstants.WInfoCircleFill} />,
        success: <Icon className={cssExports.snackBarIcon} icon={IconDefinitionConstants.WCheckCanvas} />,
        warning: <Icon className={cssExports.snackBarIcon} icon={IconDefinitionConstants.WWarningCanvas} />,
      }}
      TransitionComponent={props.TransitionComponent}
    >
      <Message isGlobal={props.isGlobal} />
      {props.children}
    </SnackbarProvider>
  );
};

export default FloatingMessageProvider;
